import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { FC } from 'react';
import { IncidentDetailPatient } from '../useIncidentDetailForHiroshima';
import { convertToPresenceAbsence } from 'core/components/common/converters';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';

type Props = {
  data: IncidentDetailPatient['incidentSituation'];
};

export const IncidentSituationView: FC<Props> = ({ data }) => {
  let motorcycleAccidentOver30Kmh = '';
  if (data?.motorcycleAccidentOver30Kmh) motorcycleAccidentOver30Kmh = '該当する';
  else if (data?.motorcycleAccidentOver30Kmh === false)
    motorcycleAccidentOver30Kmh = '該当しない';
  else motorcycleAccidentOver30Kmh = '';

  let isRescueOver20Min = '';
  if (data?.isRescueOver20Min) isRescueOver20Min = '経過';
  else if (data?.isRescueOver20Min === false) isRescueOver20Min = '未経過';
  else isRescueOver20Min = '';

  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="状況評価" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="車外放出"
            content={convertToPresenceAbsence(data?.extrication)}
          />
          <InfoDisplay
            title="同乗者死亡"
            content={convertToPresenceAbsence(data?.passengerDeath)}
          />
          <InfoDisplay
            title="車にはねられた・轢かれた"
            content={convertToPresenceAbsence(data?.vehicleHitOrRunOver)}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="運転者とバイクが離れている"
            content={convertToPresenceAbsence(data?.riderSeparatedFromBike)}
          />
          <InfoDisplay
            title="運転者とバイクの距離"
            content={
              data?.riderSeparatedFromBikeValue
                ? `${data?.riderSeparatedFromBikeValue} m`
                : ''
            }
          />
          <InfoDisplay
            title="およそ30km/h以上のバイク事故"
            content={motorcycleAccidentOver30Kmh}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="現場の外出血量"
            content={convertToPresenceAbsence(data?.isExternalBleedingAtSite)}
          />
          <InfoDisplay
            title="現場の外出血量"
            content={
              data?.externalBleedingAtSite
                ? `${data?.externalBleedingAtSite} mL`
                : ''
            }
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
            <InfoDisplay title='救出20分以上' content={isRescueOver20Min} />
            <InfoDisplay title='挟圧' content={convertToPresenceAbsence(data?.entrapment)} />
        </div>
        <div>
            <InfoDisplay title='車両大破' content={convertToPresenceAbsence(data?.vehicleMajorDamage)} />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
            <InfoDisplay title='墜落' content={convertToPresenceAbsence(data?.fall)} />
            <InfoDisplay title='墜落距離' content={data?.fallValue ? `${data?.fallValue} m` : ''} />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
            <InfoDisplay title='熱傷' content={convertToPresenceAbsence(data?.burnInjury)} />
            <InfoDisplay title='熱傷Ⅲ度' content={data?.thirdDegreeBurn ? `${data?.thirdDegreeBurn} %` : ''} />
            <InfoDisplay title='熱傷Ⅱ度' content={data?.secondDegreeBurn ? `${data?.secondDegreeBurn} %` : ''} />
        </div>
      </div>
    </BorderedContainer>
  );
};
